import { HttpClient } from '@sphere/shared/data-access/http'
import type {
  NotificationPreference,
  SetNotifPrefDto,
  ListNotifPrefsDto,
  NotificationChannel,
  NotificationTopic,
} from '@sphere/notification/domain'

const BASE_PATH = '/notification-preferences'

export const notificationsClient = {
  async getAll(filters?: ListNotifPrefsDto): Promise<NotificationPreference[]> {
    const { data } = await HttpClient.get<NotificationPreference[]>(BASE_PATH, {
      params: filters,
    })
    return data
  },

  async getOne(
    channel: NotificationChannel,
    topic: NotificationTopic
  ): Promise<NotificationPreference> {
    const { data } = await HttpClient.get<NotificationPreference>(
      `${BASE_PATH}/${channel}/${topic}`
    )
    return data
  },

  async set(dto: SetNotifPrefDto): Promise<NotificationPreference> {
    const { data } = await HttpClient.post<NotificationPreference>(
      BASE_PATH,
      dto
    )
    return data
  },

  async enableChannel(
    channel: NotificationChannel
  ): Promise<{ count: number }> {
    const { data } = await HttpClient.post<{ count: number }>(
      `${BASE_PATH}/channel/${channel}/enable`
    )
    return data
  },

  async disableChannel(
    channel: NotificationChannel
  ): Promise<{ count: number }> {
    const { data } = await HttpClient.post<{ count: number }>(
      `${BASE_PATH}/channel/${channel}/disable`
    )
    return data
  },

  async enableTopic(topic: NotificationTopic): Promise<{ count: number }> {
    const { data } = await HttpClient.post<{ count: number }>(
      `${BASE_PATH}/topic/${topic}/enable`
    )
    return data
  },

  async disableTopic(topic: NotificationTopic): Promise<{ count: number }> {
    const { data } = await HttpClient.post<{ count: number }>(
      `${BASE_PATH}/topic/${topic}/disable`
    )
    return data
  },

  async deleteAll(): Promise<{ count: number }> {
    const { data } = await HttpClient.delete<{ count: number }>(BASE_PATH)
    return data
  },
}
